<template>
    <MainContent title="Detalle de la factura">
        <template v-slot:header>
            <h3 v-if="factura" class="pb-2">{{ 'Datos de la factura Nº ' + factura.n_factura }}</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading">
                    <b-list-group-item>
                        <b>Importe total: </b> {{ factura.importe_total | formatear_precio }}
                    </b-list-group-item>
                    <b-list-group-item>
                        <b>Base Imponible </b> {{ factura.base_imponisble | formatear_precio }}  
                    </b-list-group-item>
                    <b-list-group-item>
                        <b>IVA: </b> <a>{{ factura.iva }}%</a>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b>Fecha de inicio: </b> <a>{{ factura.fecha_inicio }}</a>
                    </b-list-group-item>
                    <b-list-group-item>
                        <b>Fecha de fin: </b> {{ factura.fecha_fin }}
                    </b-list-group-item>
                    <b-list-group-item>
                        <b @click="toggleRowsVisibility" style="cursor: pointer;">
                            Filas
                            <span :class="isRowsVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></span>
                        </b>
                        <div v-if="isRowsVisible" class="ml-4 pl-2">
                            <b-list-group class="mt-2">
                                <b-list-group-item  v-for="(row, index) in factura.rows" :key="index" style="border: none; padding: 0;" class="pb-2">
                                    <b>Concepto: </b> {{ row.concepto }} <br>
                                    <b>Importe: </b> {{ row.importe | formatear_precio }}
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                    </b-list-group-item>
                    <b-list-group-item>
                        <a class="button rounded-sm" :href="factura.url_pdf + '&tid=' + teatro.hash" target="_blank">Descargar PDF</a>
                    </b-list-group-item>
                </div>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
import MainContent from '@/components/backend/components/MainContent';

export default {
    data() {
        return {
            loading: false,
            factura: null,
            isRowsVisible: false
        }
    },
    methods: {
        getFactura() {
            this.loading = true;

            const params = {
                filters: {},
                teatro_id: this.teatro.id,
                teatro_facturas_comisiones_id: this.teatro_facturas_comisiones_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.facturas.show'), params).then(res => {
                this.factura = res.data.data;
            }).catch(error => {
                this.$toast.error(error?.response?.data?.error);
            }).finally(() => {
                this.loading = false;
            });
        },
        toggleRowsVisibility() {
            this.isRowsVisible = !this.isRowsVisible;
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        teatro_facturas_comisiones_id() {
            return parseInt(this.$route.params.teatro_facturas_comisiones_id);
        }
    },
    created() {
        this.getFactura();
    },
    components: {
        MainContent
    }
}
</script>

<style>
.fa-chevron-down, .fa-chevron-up {
    font-size: 12px;
    margin-left: 5px;
    transition: transform 0.3s ease;
}
</style>
